// extracted by mini-css-extract-plugin
export var container = "_89-0";
export var fallback = "_89-5";
export var fallbackIcon = "_89-6";
export var hidden = "_89-2";
export var image = "_89-3";
export var loaded = "_89-4";
export var placeholder = "_89-1";